import {Injectable} from '@angular/core';
import {userPermissionsStore} from './user-permissions.store';
import {DashboardAccessMap} from '../../../../userway/sdk/UserWayApiClient';
import {setProps} from '@ngneat/elf';

@Injectable({providedIn: 'root'})
export class UserPermissionsManager {
  public setUserPermissions(permissions: DashboardAccessMap) {
    userPermissionsStore.update(setProps(permissions));
  }
  public reset() {
    userPermissionsStore.reset();
  }
}
